import React, { useEffect, useState } from "react";
import OverviewCard from "../components/OverView-Card/overview-card";
import InvestorChart from "../components/Dashboard/ChartComp";
import "./Dashboard.css"; // Import the CSS file
import PieChart from "../components/Dashboard/PieChart";
import axios from "axios";
import { useNavigate } from "react-router-dom";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

function Dashboard() {
  const [investorCountChart, setInvestorCountChart] = useState(null);
  const [partnerCountChart, setPartnerCountChart] = useState(null);
  const [exitedInvestorCounts, setExitedInvestorCounts] = useState(null);
  const [kycStatusData, setKycStatusData] = useState(null);

  const fetchDashboardgraphData = async () => {
    const endpoint = `${base_url}/${api_type}/dashboard-graph-chart-data`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      setExitedInvestorCounts(response?.data?.data?.exitedInvestorCounts);
      setInvestorCountChart(response?.data?.data?.investorCountChart);
      setKycStatusData(response?.data?.data?.kycStatusData);
      setPartnerCountChart(response?.data?.data?.partnerCountChart);
      console.log("grapg data", response);
      // setWatchList(response?.data?.data); // Adjust according to your API response structure
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      // setError(err.message);
    }
  };
  useEffect(() => {
    fetchDashboardgraphData();
  }, []);

  return (
    <div className="dashboard-container ">
      <OverviewCard />
      <div className="lg:grid lg:grid-cols-2 flex flex-wrap gap-5">
        {/* <div className='chart-container'> */}
        <div className="chart card overflow-auto">
          <InvestorChart
            heading="No. of investors "
            graphData={investorCountChart}
          />
        </div>
        <div className="chart card overflow-auto">
          <InvestorChart
            heading="No. of Wealth Partner"
            graphData={partnerCountChart}
          />
        </div>
        {/* </div> */}
        {/* <div className='chart-container'> */}
        {/* <div className="chart card">
          <InvestorChart />
        </div>
        <div className="chart card">
          <InvestorChart /> */}
        {/* </div> */}
      </div>
      <div className="lg:grid lg:grid-cols-2 flex flex-wrap gap-5">
        <div className="chart card overflow-auto">
          <InvestorChart
            heading="No. of investors exited"
            graphData={exitedInvestorCounts}
          />
        </div>
        <div className="chart card overflow-auto">
          <InvestorChart heading="Total Investment value " />
        </div>
      </div>
      <div className="lg:grid lg:grid-cols-2 flex flex-wrap gap-5">
        <div className="chart card overflow-auto">
          <PieChart title="Order Details" orderDetailsDatas={[]} />
        </div>
        <div className="chart card overflow-auto">
          <PieChart title="KYC Status" pieData={kycStatusData} />
        </div>
      </div>
    </div>
    // </div>
  );
}

export default Dashboard;
